import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { whatsappUrl } from '../content/siteContent';

const { FiCoffee, FiPlusSquare, FiShoppingBag, FiPackage, FiFileText, FiGrid, FiArrowRight } = FiIcons;

const options = [
  [FiCoffee, 'Comida', 'Buscamos tu comida favorita y te la llevamos.'],
  [FiPlusSquare, 'Farmacia', 'Medicamentos y productos de farmacia sin tener que salir.'],
  [FiShoppingBag, 'Compras', 'Supermercados, colmados, tiendas y comercios de Bonao.'],
  [FiPackage, 'Paquetes', 'Recogemos y entregamos paquetes de manera rápida y segura.'],
  [FiFileText, 'Documentos', 'Recogemos y llevamos documentos donde los necesites.'],
  [FiGrid, 'Otro mandao', 'Dinos qué buscas y vemos cómo resolverlo.']
];

function MandaoOptions() {
  const [selected, setSelected] = useState('Comida');

  return (
    <section className="mandao-options section" id="mandaos">
      <div className="container">
        <div className="section-heading section-heading--center">
          <span className="eyebrow">Tú pide</span>
          <h2>¿Qué mandao necesitas <em>hacer hoy?</em></h2>
          <p>Elige una opción o cuéntanos qué necesitas. Nosotros resolvemos.</p>
        </div>
        <div className="mandao-options__grid">
          {options.map(([icon, title, text], index) => (
            <motion.button
              className={`mandao-option ${selected === title ? 'is-selected' : ''}`}
              type="button"
              key={title}
              onClick={() => setSelected(title)}
              whileHover={{ y: -5 }}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.04 }}
            >
              <span><SafeIcon icon={icon} /></span>
              <strong>{title}</strong>
              <p>{text}</p>
              <i><SafeIcon icon={FiArrowRight} /></i>
            </motion.button>
          ))}
        </div>
        <div className="center-action">
          <a
            className="button button--large"
            href={whatsappUrl(`Hola Muchacho E’ Mandao, necesito un servicio de ${selected}.`)}
            target="_blank"
            rel="noreferrer"
          >
            Cuéntanos qué necesitas <SafeIcon icon={FiArrowRight} />
          </a>
        </div>
      </div>
    </section>
  );
}

export default MandaoOptions;